import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SesionService } from 'core-tsi';
import { hasActiveSession } from '@auth/utils/session';

export const accesoSucursalGuard: CanActivateFn = () => {

  const router = inject(Router)
  const sesion = inject(SesionService)

  if (!hasActiveSession()) {
    router.navigate(['/login'])
    return false
  }

  const codsuc = sesion.getSucursalSelected()

  if (codsuc && codsuc > 0) {
    return true
  }

  router.navigate(['/seleccionar-sucursal'])
  return false
}
